import React from "react";
import GroupArrowIcon from "../../../../../components/Common/SvgIcons/AdminIcons/GroupManagementIcons/GroupArrowIcon";
import EditIcon from "../../../../../components/Common/SvgIcons/TableIcons/EditIcon";
import { groupManagement } from "../../../../../utils/mainTabs/admin/groupManagement/groupManagement";
import classes from "./ManageGroupHeader.module.scss";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { setClassesOrSeriesAction } from "../../../../../store/actions/actionCreators/adminActionCreator/groupManagementActionCreator";
import { useDispatch } from "react-redux";

const ManageGroupHeader = ({ location, navigate, params, tenantName }) => {
  const dispatch = useDispatch();
  const adminStateReducer = useSelector((state) => state.adminReducer);
  const { groupManagementReducer } = adminStateReducer;
  const { manageUsersCount, manageSubgroupsCount } = groupManagementReducer;
  const path = location?.pathname;
  const groupName = localStorage.getItem("groupName");
  // const manageUsersCount = localStorage.getItem("manageUsersCount");
  // const manageSubgroupsCount = localStorage.getItem("manageSubgroupsCount");

  return (
    <>
      <div className={classes.manageUserGroupHeader}>
        <div className={classes.groupName}>
          <div
            className={classes.groupNameText}
            title={groupName?.length >= 45 && groupName}
          >
            {groupName?.length >= 45
              ? groupName?.slice(0, 45) + "..."
              : groupName}
          </div>
        </div>
        <div className={classes.manageGroup}>
          <span
            onClick={() => {
              navigate(
                `${groupManagement?.path(tenantName)}/manageUsers/${
                  params?.userGroupId
                }`
              );
            }}
          >
            <EditIcon />
          </span>
          <div
            onClick={() => {
              navigate(
                `${groupManagement?.path(tenantName)}/manageUsers/${
                  params?.userGroupId
                }`
              );
            }}
            className={
              path.includes(`${groupManagement?.path(tenantName)}/manageUsers`)
                ? classes.text + " " + classes.activeText
                : classes.text
            }
          >
            <FormattedMessage id="USERGROUP_ADDUSERBTN" />({manageUsersCount})
          </div>
        </div>
        <div className={classes.manageGroup}>
          <span
            onClick={() => {
              navigate(
                `${groupManagement?.path(tenantName)}/manageSubgroups/${
                  params?.userGroupId
                }`
              );
            }}
          >
            <EditIcon />
          </span>
          <div
            onClick={() => {
              navigate(
                `${groupManagement?.path(tenantName)}/manageSubgroups/${
                  params?.userGroupId
                }`
              );
            }}
            className={
              path.includes(
                `${groupManagement?.path(tenantName)}/manageSubgroups`
              )
                ? classes.text + " " + classes.activeText
                : classes.text
            }
          >
            <FormattedMessage id="MANAGE_SUBGROUP" />({manageSubgroupsCount})
          </div>
        </div>
        <div className={classes.manageGroup}>
          <span
            onClick={() => {
              navigate(
                `${groupManagement?.path(
                  tenantName
                )}/manageMandatoryLearnings/${params?.userGroupId}`
              );
              dispatch(setClassesOrSeriesAction([]));
            }}
          >
            <EditIcon />
          </span>
          <div
            className={
              path.includes(
                `${groupManagement?.path(tenantName)}/manageMandatoryLearnings`
              )
                ? classes.text + " " + classes.activeText
                : classes.text
            }
            onClick={() => {
              navigate(
                `${groupManagement?.path(
                  tenantName
                )}/manageMandatoryLearnings/${params?.userGroupId}`
              );
              dispatch(setClassesOrSeriesAction([]));
            }}
          >
            <FormattedMessage id="MANDATE_CLASS_USERGROUP" />
          </div>
        </div>
      </div>
      <div className={classes.manageGroupbHeading}>
        <GroupArrowIcon />
        <div className={classes.text}>
          {path.includes(
            `${groupManagement?.path(tenantName)}/manageUsers`
          ) && <FormattedMessage id="USERGROUP_EXISTINGUSERHDLBL" />}
          {path.includes(
            `${groupManagement?.path(tenantName)}/manageSubgroups`
          ) && <FormattedMessage id="EXISTING_SUBGROUPS" />}
          {path.includes(
            `${groupManagement?.path(tenantName)}/manageMandatoryLearnings`
          ) && <FormattedMessage id="MANDATE_CLASS_USERGROUP" />}
        </div>
      </div>
    </>
  );
};

export default ManageGroupHeader;
